/**
 * Application Routes
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ProtectedRoute from './ProtectedRoute';
import Layout from '../components/Layout';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Customers from '../pages/Customers';
import Providers from '../pages/Providers';
import ProviderDetailsPage from '../pages/ProviderDetailsPage';
import CustomerDetailsPage from '../pages/CustomerDetailsPage';
import Bookings from '../pages/Bookings';
import BookingDetailsPage from '../pages/BookingDetailsPage';
import Categories from '../pages/Categories';
import Services from '../pages/Services';
import Settings from '../pages/Settings';
import ContentManagement from '../pages/ContentManagement';
import Profile from '../pages/Profile';
import Support from '../pages/Support';
import Transactions from '../pages/Transactions';
import TransactionDetailsPage from '../pages/TransactionDetailsPage';
import SubscriptionPlans from '../pages/SubscriptionPlans';
import UserSubscriptions from '../pages/UserSubscriptions';

export default function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="customers" element={<Customers />} />
        <Route path="customers/:id" element={<CustomerDetailsPage />} />
        <Route path="providers" element={<Providers />} />
        <Route path="providers/:id" element={<ProviderDetailsPage />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="bookings/:id" element={<BookingDetailsPage />} />
        <Route path="categories" element={<Categories />} />
        <Route path="services" element={<Services />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="transactions/:id" element={<TransactionDetailsPage />} />
        <Route path="user-subscriptions" element={<UserSubscriptions />} />
        <Route path="subscription-plans" element={<SubscriptionPlans />} />
        <Route path="support" element={<Support />} />
        <Route path="settings" element={<Settings />} />
        <Route path="content" element={<ContentManagement />} />
        <Route path="profile" element={<Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
